import { EventsInformationActionTypes } from './action-types';
import { EventsInformationState } from 'models';
import { Reducer } from 'redux';
import { ActionTypes } from 'store/helpers';

const initialState: EventsInformationState = {
  eventsInformationList: [],
  loading: false,
  error: false,
  searchTerm: '',
};

export const reducer: Reducer<EventsInformationState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case EventsInformationActionTypes.REQUEST_EVENTS_INFORMATION:
      return {
        eventsInformationList: [],
        searchTerm: '',
        loading: true,
        error: false,
      };
    case EventsInformationActionTypes.REQUEST_EVENT_INFORMATION_SUCCESS:
      return {
        ...state,
        eventsInformationList: action.payload,
        loading: false,
      };
    case EventsInformationActionTypes.REQUEST_EVENT_INFORMATION_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case EventsInformationActionTypes.SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
      };
    default:
      return state;
  }
};
